import { defineMessages } from 'react-intl';

export const customDirectCostCreationModalMessageDefinitions = defineMessages({
  title: {
    id: 'customDirectCostCreationModal.title',
    defaultMessage: 'Create Custom Cost',
  },
  costName: {
    id: 'customDirectCostCreationModal.costName',
    defaultMessage: 'Cost Name',
  },
  estimationGroup: {
    id: 'customDirectCostCreationModal.estimationGroup',
    defaultMessage: 'Estimation Group',
  },
  description: {
    id: 'customDirectCostCreationModal.description',
    defaultMessage: 'Description',
  },
  descriptionPlaceholder: {
    id: 'customDirectCostCreationModal.descriptionPlaceholder',
    defaultMessage: 'Meaningful short description for management (max 210 characters)',
  },
});
